// src/pages/impots/EcheancesTaxPage/PaiementSuccesPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Button, Badge, Container, Spinner, Row, Col, Alert, Modal, ListGroup, Form } from "react-bootstrap";
import { CheckCircle, Search, ArrowLeft, Printer, FilePdf, Usb, InfoCircle, ExclamationTriangle, UsbC, Person, Building, Phone, Envelope } from "react-bootstrap-icons";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import logo from "../../assets/img/logo2.png";
import mairieLogo1 from "../../assets/img/nrf.png";
import mairieLogo2 from "../../assets/img/image.jpeg";
import mairieLogo from "../../assets/img/nrf.png";
import axios from "axios";
import QRCode from 'qrcode';
import { API_BASE_URL } from "../../constants/api_constants";

// const API_BASE_URL = process.env.REACT_APP_API_URL;
const LOCALITES_ENDPOINT = `${API_BASE_URL}/localites`;
const PAYMENT_ENDPOINT = `${API_BASE_URL}/payments`;

// ==================== FORMATAGE PÉRIODE (mois en français) ====================
const MOIS_FR_LOCAL = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];
const MOIS_ANGLAIS = [
  "january", "february", "march", "april", "may", "june",
  "july", "august", "september", "october", "november", "december",
];

/**
 * Convertit une valeur de période en français :
 *   - "05/08/2027"              → "5 août 2027"
 *   - "2026-10-15"              → "15 octobre 2026"
 *   - "01/10/2026 - 31/10/2026" → "1 octobre 2026 - 31 octobre 2026"
 *   - "October 2026"            → "octobre 2026"
 *   - "MM/YYYY" ou "YYYY-MM"    → "mois année" (sans jour)
 */
const formatPeriodeFr = (raw) => {
  if (!raw) return "-";
  const s = String(raw).trim();

  // 1) Plage "d/m/Y - d/m/Y" → on traduit chaque date
  if (/^\d{2}\/\d{2}\/\d{4}\s*-\s*\d{2}\/\d{2}\/\d{4}$/.test(s)) {
    const [debut, fin] = s.split(/\s*-\s*/);
    const toFr = (d) => {
      const m = d.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!m) return d;
      const [, jj, mm, aaaa] = m;
      const idx = parseInt(mm, 10) - 1;
      if (idx < 0 || idx > 11) return d;
      return `${parseInt(jj, 10)} ${MOIS_FR_LOCAL[idx]} ${aaaa}`;
    };
    return `${toFr(debut)} - ${toFr(fin)}`;
  }

  // 2) Date simple "d/m/Y" → "5 août 2027"
  const matchDMY = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (matchDMY) {
    const [, jj, mm, aaaa] = matchDMY;
    const idx = parseInt(mm, 10) - 1;
    if (idx >= 0 && idx <= 11) {
      return `${parseInt(jj, 10)} ${MOIS_FR_LOCAL[idx]} ${aaaa}`;
    }
  }

  // 3) ISO "YYYY-MM-DD..." → "15 octobre 2026"
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const d = new Date(s);
    if (!isNaN(d.getTime())) {
      return `${d.getDate()} ${MOIS_FR_LOCAL[d.getMonth()]} ${d.getFullYear()}`;
    }
  }

  // 4) "October 2026" / "octobre 2026" → "octobre 2026"
  const lower = s.toLowerCase();
  const matchMois = lower.match(/^([a-zéûôàèç]+)\s+(\d{4})$/);
  if (matchMois) {
    const [, mois, annee] = matchMois;
    let idx = MOIS_ANGLAIS.indexOf(mois);
    if (idx === -1) idx = MOIS_FR_LOCAL.indexOf(mois);
    if (idx !== -1) return `${MOIS_FR_LOCAL[idx]} ${annee}`;
  }

  // 5) "MM/YYYY" ou "YYYY-MM"
  const matchNum = lower.match(/^(\d{1,2})[\/\-](\d{4})$/) || lower.match(/^(\d{4})[\/\-](\d{1,2})$/);
  if (matchNum) {
    const [a, b] = matchNum.slice(1);
    const m = a.length === 4 ? parseInt(b, 10) : parseInt(a, 10);
    const y = a.length === 4 ? a : b;
    if (m >= 1 && m <= 12) return `${MOIS_FR_LOCAL[m - 1]} ${y}`;
  }

  return s;
};
// ==================== FIN FORMATAGE PÉRIODE ====================

const PaiementSuccesPage = () => {
  const { reference } = useParams();
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState(null);
  const [contribuable, setContribuable] = useState(null);
  const [localiteInfo, setLocaliteInfo] = useState(null);
  const [loadingLocalite, setLoadingLocalite] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [allLocalites, setAllLocalites] = useState([]);
  const [echeanceDetails, setEcheanceDetails] = useState(null);
  const [loadingEcheance, setLoadingEcheance] = useState(false);
  const [agentInfo, setAgentInfo] = useState(null);
  const [loadingAgent, setLoadingAgent] = useState(false);

  const [paiementComplet, setPaiementComplet] = useState(null);

  const [showUsbModal, setShowUsbModal] = useState(false);
  const [usbDevices, setUsbDevices] = useState([]);
  const [scanningUsb, setScanningUsb] = useState(false);
  const [selectedUsbDevice, setSelectedUsbDevice] = useState(null);
  const [printingUsb, setPrintingUsb] = useState(false);
  const [usbStatus, setUsbStatus] = useState('');
  const [usbError, setUsbError] = useState('');

  const [showSerialModal, setShowSerialModal] = useState(false);
  const [serialStatus, setSerialStatus] = useState('');
  const [selectedPort, setSelectedPort] = useState(null);
  const [baudRate, setBaudRate] = useState(9600);
  const [activiteInfo, setActiviteInfo] = useState(null);

  const defaultCurrency = sessionStorage.getItem("default_currency") || 'FC';
  const [printingPaymentId, setPrintingPaymentId] = useState(null);
  const getAuthToken = () => sessionStorage.getItem("authToken");

  const getHeaders = () => {
    const token = getAuthToken();
    return {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  };

  const fetchPaymentByReference = async (ref) => {
    try {
      console.log("=== RECHERCHE PAIEMENT PAR RÉFÉRENCE ===");
      console.log("Référence:", ref);

      const response = await axios.get(`${PAYMENT_ENDPOINT}/${ref}`, { headers: getHeaders() });

      console.log("Réponse API paiement complète:", JSON.stringify(response.data, null, 2));

      if (response.data && response.data.code === 200 && response.data.paiement) {
        const paiementData = response.data.paiement;

        setPaiementComplet(paiementData);

        const categorieTaxe = response.data.categorie_taxe;
        paiementData.categorie_taxe = categorieTaxe;

        if (paiementData.echeance) {
          const echeance = paiementData.echeance;

          setEcheanceDetails({
            montant_initial: parseFloat(echeance.montant_initial || 0),
            montant_attendu: parseFloat(echeance.montant_attendu || 0),
            montant_paye: parseFloat(echeance.montant_paye || 0),
            montant_restant: Math.max(0,
              (parseFloat(echeance.montant_initial || echeance.montant_attendu || 0)) -
              parseFloat(echeance.montant_paye || 0)
            ),
            date_echeance: echeance.date_echeance,
            statut: echeance.statut
          });
        } else {
          if (paiementData.echeance_id) {
            await fetchEcheanceDetails(paiementData.echeance_id);
          }
        }

        let agentData = null;

        if (paiementData.agent && Object.keys(paiementData.agent).length > 0) {
          agentData = paiementData.agent;
        } else if (paiementData.agent_user && Object.keys(paiementData.agent_user).length > 0) {
          agentData = paiementData.agent_user;
        } else if (paiementData.agent_relation && Object.keys(paiementData.agent_relation).length > 0) {
          agentData = paiementData.agent_relation;
        }

        if (agentData) {
          setAgentInfo({
            id: agentData.user_id || agentData.id,
            nom: agentData.admin_lname || agentData.last_name || agentData.full_name?.split(' ')[1] || '',
            prenom: agentData.admin_fname || agentData.first_name || agentData.full_name?.split(' ')[0] || '',
            fonction: agentData.admin_fonction || agentData.fonction || agentData.role?.name || "Agent de collecte",
            matricule: agentData.matricule_interne || '',
            email: agentData.email,
            telephone: agentData.admin_phone || agentData.telephone
          });
        } else {
          const user = JSON.parse(sessionStorage.getItem("user") || "{}");
          if (user && (user.user_id || user.id)) {
            setAgentInfo({
              id: user.user_id || user.id,
              nom: user.admin_lname || user.last_name || '',
              prenom: user.admin_fname || user.first_name || '',
              fonction: user.admin_fonction || user.fonction || "Agent de collecte",
              matricule: user.matricule_interne || user.code_agent_interne || '',
              email: user.email,
              telephone: user.admin_phone || user.telephone
            });
          }
        }

        const activiteData = response.data.activite;
        paiementData.activite = activiteData;

        return paiementData;
      }
      return null;
    } catch (error) {
      console.error("Erreur récupération paiement:", error);
      if (error.response?.status === 404) {
        setApiError("Paiement non trouvé");
      }
      return null;
    }
  };

  const fetchEcheanceDetails = async (echeanceId) => {
    if (!echeanceId) return null;

    setLoadingEcheance(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/terms?echeance_id=${echeanceId}`, {
        headers: getHeaders()
      });

      if (response.data && response.data.echeances && response.data.echeances.length > 0) {
        const echeance = response.data.echeances[0];

        const echeanceData = {
          montant_initial: parseFloat(echeance.montant_initial || 0),
          montant_attendu: parseFloat(echeance.montant_attendu || 0),
          montant_paye: parseFloat(echeance.montant_paye || 0),
          montant_restant: Math.max(0, (parseFloat(echeance.montant_initial || echeance.montant_attendu || 0)) - parseFloat(echeance.montant_paye || 0)),
          date_echeance: echeance.date_echeance,
          statut: echeance.statut
        };
        setEcheanceDetails(echeanceData);
        return echeanceData;
      }
      return null;
    } catch (error) {
      console.error("Erreur chargement échéance:", error);
      return null;
    } finally {
      setLoadingEcheance(false);
    }
  };

  const fetchAllLocalites = async () => {
    try {
      const response = await axios.get(LOCALITES_ENDPOINT, { headers: getHeaders() });

      let localitesArray = [];
      if (response.data && Array.isArray(response.data)) {
        localitesArray = response.data;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        localitesArray = response.data.data;
      }

      setAllLocalites(localitesArray);
      return localitesArray;
    } catch (error) {
      console.error("Erreur chargement localités:", error);
      setApiError(`Erreur chargement localités: ${error.message}`);
      return [];
    }
  };

  const getParentChain = (localitesList, localiteId, chain = []) => {
    if (!localiteId) return chain;

    const current = localitesList.find(l => l.localite_id === localiteId);
    if (!current) return chain;

    chain.unshift(current);

    if (current.parent_id) {
      return getParentChain(localitesList, current.parent_id, chain);
    }

    return chain;
  };

  const extractLocationInfoFromChain = (chain) => {
    let province = null;
    let departement = null;
    let ville = null;
    let commune = null;
    let arrondissement = null;
    let quartier = null;
    let pays = null;
    let avenue = null;
    let numero = null;

    chain.forEach(loc => {
      if (loc.pays_code && !pays) {
        pays = loc.pays_code === "CD" ? "RDC" : loc.pays_code;
      }

      if (loc.avenue && !avenue) avenue = loc.avenue;
      if (loc.numero && !numero) numero = loc.numero;

      switch (loc.type_code) {
        case 1005: if (!province) province = loc.nom; break;
        case 1004: if (!departement) departement = loc.nom; break;
        case 1001: if (!ville) ville = loc.nom; break;
        case 1000: if (!commune) commune = loc.nom; break;
        case 1003: if (!arrondissement) arrondissement = loc.nom; break;
        case 1002: if (!quartier) quartier = loc.nom; break;
        default: break;
      }
    });

    const adresseParts = [];
    if (avenue) adresseParts.push(avenue);
    if (numero) adresseParts.push(`N°${numero}`);
    if (quartier) adresseParts.push(`Q. ${quartier}`);
    if (commune) adresseParts.push(`Commune de ${commune}`);
    if (ville) adresseParts.push(ville);
    if (departement) adresseParts.push(departement);
    if (province) adresseParts.push(province);

    const result = {
      province,
      departement,
      ville,
      commune,
      arrondissement,
      quartier,
      pays: pays || "",
      avenue,
      numero,
      adresseComplete: adresseParts.join(', '),
      chaineComplete: chain
    };

    return result;
  };

  const fetchContribuableLocalite = async (contribuableData) => {
    if (!contribuableData || !contribuableData.localite_id) {
      setLocaliteInfo({
        adresseComplete: contribuableData?.adresse || "",
        pays: ""
      });
      return;
    }

    setLoadingLocalite(true);
    try {
      let localitesData = allLocalites;
      if (localitesData.length === 0) {
        localitesData = await fetchAllLocalites();
      }

      const localiteId = contribuableData.localite_id;
      if (localiteId && localitesData.length > 0) {
        const foundLocalite = localitesData.find(l => l.localite_id === localiteId);
        if (foundLocalite) {
          const chain = getParentChain(localitesData, localiteId, []);
          if (chain.length > 0) {
            const locationInfo = extractLocationInfoFromChain(chain);
            setLocaliteInfo(locationInfo);
            return;
          }
        }
      }
      setLocaliteInfo({
        adresseComplete: contribuableData.adresse || "",
        pays: ""
      });
    } catch (error) {
      console.error("Erreur chargement localité:", error);
      setLocaliteInfo({
        adresseComplete: contribuableData.adresse || "",
        pays: ""
      });
    } finally {
      setLoadingLocalite(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      const paiementData = await fetchPaymentByReference(reference);

      const activiteData = paiementData?.activite;

      setActiviteInfo(activiteData);

      if (paiementData) {
        const nomActivite = paiementData.activite?.name ||
                            paiementData.activite_nom ||
                            paiementData.contribuable?.activite?.name ||
                            "Activité non spécifiée";

        const categorieTaxe = paiementData.categorie_taxe;

        const transactionData = {
          reference: paiementData.reference_paiement,
          nom_activite: nomActivite,
          amount: parseFloat(paiementData.montant),
          currency: paiementData.currency || defaultCurrency,
          timestamp: paiementData.date_paiement,
          paymentMethod: paiementData.methode,
          paymentType: paiementData.partial_amount ? "partial" : "full",
          partialAmount: paiementData.partial_amount,
          phoneNumber: paiementData.client_phone,
          contribuableId: paiementData.usager_id,
          taxName: paiementData.taxe?.titre,
          montant_attendu: paiementData.echeance?.montant_attendu,
          period: paiementData.period_label,
          echeanceId: paiementData.echeance_id,
          status: paiementData.statut,
          categorieTaxe: categorieTaxe?.nom || categorieTaxe?.category_name || "Non spécifiée",
          activite: activiteData
        };

        setTransaction(transactionData);

        if (paiementData.contribuable) {
          setContribuable(paiementData.contribuable);
          await fetchContribuableLocalite(paiementData.contribuable);
        }

        if (paiementData.echeance_id) {
          await fetchEcheanceDetails(paiementData.echeance_id);
        }
      } else {
        const storedTransaction = localStorage.getItem('pendingTransaction');
        if (storedTransaction) {
          const transactionData = JSON.parse(storedTransaction);
          if (transactionData.reference === reference) {
            setTransaction(transactionData);
            if (transactionData.contribuableId) {
              const contribuableResponse = await axios.get(
                `${API_BASE_URL}/taxpayers/${transactionData.contribuableId}`,
                { headers: getHeaders() }
              );
              if (contribuableResponse.data) {
                setContribuable(contribuableResponse.data);
                await fetchContribuableLocalite(contribuableResponse.data);
              }
            }
          }
        }
      }
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reference]);

  const formatCurrency = (amount, currency = defaultCurrency) => {
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + ' ' + currency;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Non spécifié";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Date invalide";
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "Non spécifié";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Date invalide";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} à ${hours}:${minutes}`;
  };

  const getPaymentMethodLabel = () => {
    const methods = {
      'cash': 'Espèces',
      'credit_card': 'Carte Bancaire',
      'mobile_money': 'Mobile Money',
      'check': 'Chèque',
      'bank_transfer': 'Virement bancaire',
      'AM': 'Airtel Money',
      'card': 'Carte bancaire',
      'bank': 'Virement'
    };
    return methods[transaction?.paymentMethod] || transaction?.paymentMethod || 'Autre';
  };

  const formatDateShort = (dateString) => {
    if (!dateString) return "Non spécifié";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Date invalide";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // ==================== GÉNÉRATION DU BORDEREAU DE PAIEMENT ====================

  const generateBordereauPaiement = async (paiement) => {
    if (!paiement) {
      alert("Impossible de générer le document : données de paiement manquantes");
      return;
    }

    setPrintingPaymentId(paiement.id);

    const receiptNumber = paiement?.reference_paiement || `RCP-${Date.now()}`;
    const currentDate = new Date();

    const datePaiementBordereau =
      paiement?.date_paiement ||
      paiement?.created_at ||
      currentDate;

    const formatDateShortBordereau = (date) => {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const fileName = `QUITTANCE_${receiptNumber}_${formatDateShortBordereau(datePaiementBordereau)}`;
    const originalTitle = document.title;
    document.title = fileName;

    // ✅ Période : utilise formatPeriodeFr (mois en français)
    const rawPeriodeBordereau =
      paiement?.echeance?.date_echeance ||
      paiement?.echeance_periode ||
      paiement?.period_label;

    const periodLabel = rawPeriodeBordereau
      ? formatPeriodeFr(rawPeriodeBordereau)
      : "Période non spécifiée";

    const montantTransaction = parseFloat(paiement?.montant || 0);
    const montantInitialEcheance = parseFloat(paiement?.echeance?.montant_initial || paiement?.echeance?.montant_attendu || montantTransaction);
    const totalPayeEcheance = parseFloat(paiement?.echeance?.montant_paye || montantTransaction);
    const montantRestantEcheance = Math.max(0, montantInitialEcheance - totalPayeEcheance);
    const montantPayeAvant = totalPayeEcheance - montantTransaction;

    let adresseComplete = paiement?.contribuable?.adresse || "";

    if (paiement?.contribuable?.localite_id && allLocalites.length > 0) {
      const foundLocalite = allLocalites.find(l => l.localite_id === paiement.contribuable.localite_id);
      if (foundLocalite) {
        const chain = getParentChain(allLocalites, paiement.contribuable.localite_id, []);
        const locationInfo = extractLocationInfoFromChain(chain);
        adresseComplete = locationInfo.adresseComplete || paiement?.contribuable?.adresse || "";
      }
    }

    const agentNom = paiement?.agent?.admin_fname || paiement?.agent?.admin_lname ?
      `${paiement.agent.admin_fname || ''} ${paiement.agent.admin_lname || ''}`.trim() || "Agent"
      : "Agent non spécifié";

    let qrCodeBase64 = '';

    try {
      const qrResponse = await axios.post(
        `${API_BASE_URL}/qrcode`,
        { payment_id: String(receiptNumber) },
        { headers: getHeaders() }
      );

      if (qrResponse.data && qrResponse.data.rid) {
        qrCodeBase64 = await QRCode.toDataURL(qrResponse.data.rid, {
          width: 100,
          margin: 1,
          color: { dark: '#1a3c5e', light: '#ffffff' }
        });
      }
    } catch (error) {
      console.error("Erreur génération QR Code:", error);
    }

    const getPaymentMethodLabelLocal = () => {
      const methods = {
        'cash': 'Espèces',
        'credit_card': 'Carte Bancaire',
        'mobile_money': 'Mobile Money',
        'check': 'Chèque',
        'bank_transfer': 'Virement bancaire',
        'AM': 'Airtel Money',
        'card': 'Carte bancaire',
        'bank': 'Virement'
      };
      return methods[paiement?.methode?.toLowerCase()] || paiement?.methode || 'Autre';
    };

    const getActiviteNomLocal = () => {
      if (paiement?.nom_activite) return paiement.nom_activite;
      if (paiement?.activite?.name) return paiement.activite.name;
      if (paiement?.activite_nom) return paiement.activite_nom;
      return "Activité non spécifiée";
    };

    const formatDateBordereau = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const formatCurrencyBordereau = (amount) => {
      const num = parseFloat(amount) || 0;
      return num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + defaultCurrency;
    };

    const htmlContent = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>${fileName}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    @page { size: A4 portrait; margin: 12mm 15mm 12mm 15mm; }
    html, body {
      width: 210mm; min-height: 297mm; margin: 0; padding: 0;
      background: white;
      font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
      font-size: 10pt; color: #2c3e50; line-height: 1.5;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .receipt { width: 100%; min-height: 100%; background: white; padding: 0; display: flex; flex-direction: column; justify-content: space-between; }
    .header { border-bottom: 3px solid #1a3c5e; padding-bottom: 10px; margin-bottom: 12px; }
    .header-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
    .header-left { display: flex; flex-direction: column; }
    .header-title { font-size: 18pt; font-weight: bold; color: #1a3c5e; letter-spacing: 1px; }
    .header-subtitle { font-size: 9pt; color: #6c757d; margin-top: 2px; }
    .header-right { display: flex; align-items: center; gap: 15px; }
    .document-number { font-size: 11pt; font-weight: bold; color: #1a3c5e; text-align: right; }
    .document-number .label { font-size: 7pt; text-transform: uppercase; color: #6c757d; font-weight: normal; display: block; }
    .qrcode-container { text-align: center; }
    .qrcode-image { width: 55px; height: 55px; border: 1px solid #dee2e6; border-radius: 4px; padding: 3px; background: white; }
    .qrcode-label { font-size: 6pt; color: #6c757d; }
    .receipt-meta { display: flex; justify-content: space-between; margin-top: 8px; padding-top: 8px; border-top: 1px dashed #dee2e6; }
    .meta-item { text-align: center; flex: 1; }
    .meta-label { font-size: 7pt; text-transform: uppercase; color: #6c757d; letter-spacing: 0.5px; }
    .meta-value { font-size: 10pt; font-weight: bold; color: #1a3c5e; margin-top: 2px; }
    .meta-value.status-paid { color: #28a745; }
    .meta-value.status-partial { color: #dc3545; }
    .title { text-align: center; margin: 10px 0 14px 0; }
    .title h2 { font-size: 16pt; color: #28a745; text-transform: uppercase; letter-spacing: 2px; font-weight: bold; }
    .content { flex: 1; display: flex; flex-direction: column; }
    .sections { display: flex; gap: 25px; margin-bottom: 14px; }
    .section { flex: 1; }
    .section-title { font-size: 9pt; font-weight: bold; color: #1a3c5e; text-transform: uppercase; border-bottom: 2px solid #1a3c5e; padding-bottom: 5px; margin-bottom: 8px; letter-spacing: 0.5px; }
    .info-line { margin-bottom: 4px; font-size: 10pt; display: flex; padding: 2px 0; }
    .info-label { color: #6c757d; min-width: 85px; font-size: 9pt; flex-shrink: 0; }
    .info-value { color: #2c3e50; font-weight: 500; font-size: 10pt; word-break: break-word; }
    .amount-table { background: #f8f9fa; padding: 14px 18px; margin: 8px 0 16px 0; border-radius: 6px; border: 1px solid #e9ecef; }
    .amount-row { display: flex; justify-content: space-between; padding: 5px 0; font-size: 10pt; }
    .amount-row.border-bottom { border-bottom: 1px solid #dee2e6; padding-bottom: 6px; margin-bottom: 4px; }
    .amount-row.highlight { background: #d4edda; margin: 5px -14px; padding: 6px 14px; border-radius: 4px; }
    .amount-row.highlight .amount-value { font-weight: bold; color: #28a745; font-size: 11pt; }
    .amount-row.total { margin-top: 4px; padding-top: 8px; border-top: 2px solid #1a3c5e; font-size: 11pt; font-weight: bold; }
    .amount-row.total .amount-value { font-size: 12pt; color: #28a745; }
    .amount-row .amount-value.restant { color: #dc3545; font-weight: bold; }
    .amount-row .amount-value.zero { color: #28a745; }
    .signature-row { display: flex; justify-content: space-between; margin-top: 20px; padding-top: 14px; border-top: 1.5px solid #dee2e6; }
    .signature-col { width: 45%; text-align: center; }
    .sig-line { width: 160px; height: 1.5px; background: #333; margin: 0 auto 4px auto; }
    .sig-fonction { font-size: 9pt; font-weight: 600; color: #555; }
    .sig-nom { font-size: 8pt; color: #666; font-style: italic; }
    .footer-bottom { margin-top: 12px; padding-top: 10px; border-top: 1px solid #e9ecef; font-size: 7pt; color: #adb5bd; display: flex; justify-content: space-between; }
  </style>
</head>
<body>
<div class="receipt">
  <div class="header">
    <div class="header-top">
      <div><div class="header-title">SYNCTAXE</div><div class="header-subtitle">Plateforme de gestion fiscale</div></div>
      <div style="display:flex; align-items:center; gap:15px;">
        <div class="document-number"><span class="label">Quittance N°</span>${receiptNumber}</div>
        ${qrCodeBase64 ? `<div><img src="${qrCodeBase64}" alt="QR" class="qrcode-image" /><div class="qrcode-label">Vérification</div></div>` : ""}
      </div>
    </div>
    <div class="receipt-meta">
      <div class="meta-item"><div class="meta-label">Date d'émission</div><div class="meta-value">${formatDateBordereau(datePaiementBordereau)}</div></div>
      <div class="meta-item"><div class="meta-label">Méthode</div><div class="meta-value">${getPaymentMethodLabelLocal()}</div></div>
      <div class="meta-item"><div class="meta-label">Statut</div><div class="meta-value ${montantRestantEcheance > 0 ? 'status-partial' : 'status-paid'}">${montantRestantEcheance > 0 ? 'PAIEMENT PARTIEL' : 'PAYÉ INTÉGRALEMENT'}</div></div>
    </div>
  </div>
  <div class="title"><h2>QUITTANCE DE PAIEMENT</h2></div>
  <div class="content">
    <div class="sections">
      <div class="section">
        <div class="section-title">Contribuable</div>
        <div class="info-line"><span class="info-label">Nom complet</span><span class="info-value">${paiement?.contribuable?.nom_contribuable || paiement?.nom_contribuable || 'Non spécifié'}</span></div>
        <div class="info-line"><span class="info-label">Identifiant</span><span class="info-value">${paiement?.usager_id || 'N/A'}</span></div>
        <div class="info-line"><span class="info-label">Téléphone</span><span class="info-value">${paiement?.client_phone || 'Non spécifié'}</span></div>
        <div class="info-line"><span class="info-label">Adresse</span><span class="info-value">${adresseComplete}</span></div>
      </div>
      <div class="section">
        <div class="section-title">Taxe et activité</div>
        <div class="info-line"><span class="info-label">Désignation</span><span class="info-value">${paiement?.taxe?.titre || 'Taxe'}</span></div>
        <div class="info-line"><span class="info-label">Activité</span><span class="info-value">${getActiviteNomLocal()}</span></div>
        <div class="info-line"><span class="info-label">Période</span><span class="info-value">${periodLabel}</span></div>
        <div class="info-line"><span class="info-label">Agent</span><span class="info-value">${agentNom}</span></div>
      </div>
    </div>
    <div class="amount-table">
      <div class="amount-row border-bottom"><span class="amount-label">Montant total de l'échéance</span><span class="amount-value">${formatCurrencyBordereau(montantInitialEcheance)}</span></div>
      <div class="amount-row border-bottom"><span class="amount-label">Déjà payé (antérieur)</span><span class="amount-value">${formatCurrencyBordereau(montantPayeAvant)}</span></div>
      <div class="amount-row highlight"><span class="amount-label">Montant payé (cette transaction)</span><span class="amount-value">${formatCurrencyBordereau(montantTransaction)}</span></div>
      <div class="amount-row total"><span class="amount-label">TOTAL PAYÉ À CE JOUR</span><span class="amount-value">${formatCurrencyBordereau(totalPayeEcheance)}</span></div>
      <div class="amount-row"><span class="amount-label">RESTE À PAYER</span><span class="amount-value ${montantRestantEcheance > 0 ? "restant" : "zero"}">${formatCurrencyBordereau(montantRestantEcheance)}</span></div>
    </div>
    <div class="signature-row">
      <div class="signature-col"><div class="sig-line"></div><div class="sig-fonction">LE CONTRIBUABLE</div><div class="sig-nom">${paiement?.contribuable?.nom_contribuable || paiement?.nom_contribuable || '__________________'}</div></div>
      <div class="signature-col"><div class="sig-line"></div><div class="sig-fonction">LE COMPTABLE / AGENT</div><div class="sig-nom">META KABAMBA Mimie</div></div>
    </div>
  </div>
  <div class="footer-bottom">
    <div>Généré le ${new Date().toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</div>
    <div>${defaultCurrency} • SyncTaxe</div>
  </div>
</div>
</body>
</html>`;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.document.title = fileName;
      iframe.contentWindow.print({
        printBackground: true,
        shrinkToFit: true
      });

      setTimeout(() => {
        document.title = originalTitle;
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
        setPrintingPaymentId(null);
      }, 1500);
    };
  };

  // ==================== GÉNÉRATION DE LA NOTE DE PERCEPTION ====================

  const generateNotePerception = async () => {
    let fullPaiement = paiementComplet;
    let fullContribuable = contribuable;
    let fullEcheance = echeanceDetails;

    if (!fullPaiement && transaction?.reference) {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/payments/${transaction.reference}`,
          { headers: getHeaders() }
        );

        if (response.data && response.data.code === 200 && response.data.paiement) {
          fullPaiement = response.data.paiement;
          fullContribuable = response.data.paiement?.contribuable || contribuable;
          fullEcheance = response.data.echeance || echeanceDetails;
        }
      } catch (error) {
        if (error.response?.status === 404) {
          console.warn(
            `⚠️ /payments/${transaction.reference} → 404. Utilisation des données de la liste.`
          );
        } else {
          console.error("❌ Erreur chargement données complètes:", error);
        }
      }
    }

    const contribuableAdresse = fullContribuable?.adresse || "";
    const contribuableLocaliteId = fullContribuable?.localite_id || fullPaiement?.localite_id;

    let communeNom = "";
    let adresseAffichage = contribuableAdresse || "";

    if (contribuableLocaliteId && allLocalites && allLocalites.length > 0) {
      try {
        const foundLocalite = allLocalites.find((l) => l.localite_id === contribuableLocaliteId);
        if (foundLocalite) {
          const chain = getParentChain(allLocalites, contribuableLocaliteId, []);
          const locationInfo = extractLocationInfoFromChain(chain);
          communeNom = locationInfo.commune || "";
        }
      } catch (error) {
        console.error("Erreur récupération localité:", error);
      }
    }

    let documentInfo = { id_doc: null, date_create: null };
    try {
      const documentResponse = await axios.get(`${API_BASE_URL}/document`, { headers: getHeaders() });
      if (documentResponse.data && documentResponse.data.id_doc) {
        documentInfo.id_doc = documentResponse.data.id_doc;
        documentInfo.date_create = documentResponse.data.date_create;
      } else {
        documentInfo.id_doc = fullPaiement?.reference_paiement || `NP-${Date.now()}`;
        documentInfo.date_create = new Date().toISOString().slice(0, 19).replace("T", " ");
      }
    } catch (error) {
      documentInfo.id_doc = fullPaiement?.reference_paiement || `NP-${Date.now()}`;
      documentInfo.date_create = new Date().toISOString().slice(0, 19).replace("T", " ");
    }

    const receiptNumber = documentInfo.id_doc || transaction?.reference || `NP-${Date.now()}`;
    const currentDate = new Date();

    const datePaiement =
      fullPaiement?.date_paiement ||
      fullPaiement?.created_at ||
      transaction?.timestamp ||
      currentDate;

    const datePaiementObj = new Date(datePaiement);

    const datePaiementAffichee =
      !isNaN(datePaiementObj.getTime())
        ? datePaiementObj.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        : currentDate.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });

    const formatDateShortForFile = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
    };

    const fileName = `NOTE_PERCEPTION_${receiptNumber}_${formatDateShortForFile(datePaiementObj)}`;
    const originalTitle = document.title;
    document.title = fileName;

    const formatCurrencyNP = (amount) => {
      const num = parseFloat(amount) || 0;
      return num.toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + " " + defaultCurrency;
    };

    // ✅ Période = date d'échéance, traduite en français
    let periodeEcheance = "";

    const rawPeriode =
      fullEcheance?.date_echeance ||
      fullPaiement?.echeance?.date_echeance ||
      fullPaiement?.echeance_periode ||
      transaction?.period;

    if (rawPeriode) {
      periodeEcheance = formatPeriodeFr(rawPeriode);
    }
    if (!periodeEcheance) periodeEcheance = "Période non spécifiée";

    const montantTransaction = parseFloat(fullPaiement?.montant || transaction?.amount || 0);
    const montantInitialEcheance = parseFloat(
      fullEcheance?.montant_initial || fullPaiement?.echeance?.montant_initial || montantTransaction
    );
    const totalPayeEcheance = parseFloat(
      fullEcheance?.montant_paye || fullPaiement?.echeance?.montant_paye || montantTransaction
    );
    const montantRestantEcheance = Math.max(0, montantInitialEcheance - totalPayeEcheance);

    const agentTaxateurNom = "Franck KASONGO";
    const agentTaxateurQualite = "Chef de Service Économie";
    const ordonnateurNom = "NHUNGA MAKENGO Jacqueline";
    const comptableNom = "META KABAMBA Mimie";

    const taxeLibelle =
      fullPaiement?.taxe_titre ||
      fullPaiement?.taxe?.titre ||
      fullPaiement?.taxe?.nom ||
      transaction?.taxName ||
      "Taxe professionnelle";

    const nomContribuable =
      fullContribuable?.nom_contribuable ||
      fullPaiement?.nom_contribuable ||
      contribuable?.nom_contribuable ||
      "__________________";

    const montantEnLettres = convertirMontantEnLettres(montantTransaction) + " " + defaultCurrency;

    const getPaymentMethodLabelLocal = () => {
      const methods = {
        cash: "Espèces",
        credit_card: "Carte Bancaire",
        mobile_money: "Mobile Money",
        check: "Chèque",
        bank_transfer: "Virement bancaire",
        AM: "Airtel Money",
        card: "Carte bancaire",
        bank: "Virement",
      };
      return methods[fullPaiement?.methode?.toLowerCase()] || fullPaiement?.methode || transaction?.paymentMethod || "Espèces";
    };

    const bordereauNumber = fullPaiement?.reference_paiement || receiptNumber || `TX${Date.now()}`;

    let qrCodeBase64 = "";
    try {
      const qrResponse = await axios.post(
        `${API_BASE_URL}/qrcode`,
        { payment_id: String(fullPaiement?.reference_paiement || receiptNumber) },
        { headers: getHeaders() }
      );
      if (qrResponse.data && qrResponse.data.rid) {
        qrCodeBase64 = await QRCode.toDataURL(qrResponse.data.rid, {
          width: 80,
          margin: 1,
          color: { dark: "#000000", light: "#ffffff" },
        });
      }
    } catch (error) {
      console.error("❌ Erreur QR Code:", error);
    }

    const htmlContent = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="UTF-8">
<title>${fileName}</title>
<style>
  @page { size: A4 portrait; margin: 0; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body {
    width: 210mm; height: 297mm; margin: 0; padding: 0;
    background: #fff;
    font-family: 'Arial', 'Helvetica', sans-serif;
    font-size: 9pt; color: #000; line-height: 1.25; overflow: hidden;
  }
  .page {
    width: 100%; height: 297mm;
    padding: 30mm 12mm 8mm 12mm;
    display: flex; flex-direction: column; box-sizing: border-box;
  }
  .main-title {
    text-align: center; font-size: 12pt; font-weight: bold;
    text-transform: uppercase; letter-spacing: 0.8px;
    margin-bottom: 4pt; padding-bottom: 3pt;
    border-bottom: 1.5px solid #000;
  }
  .doc-header {
    display: flex; justify-content: space-between; align-items: center;
    font-size: 9pt; margin-bottom: 4pt; padding-bottom: 2pt;
  }
  .doc-header .label { font-weight: bold; font-size: 10pt; }
  .doc-header .date { font-size: 8.5pt; }
  .section { border: 1.1px solid #000; margin-bottom: 5pt; }
  .section-title {
    background: #d9d9d9; font-weight: bold; font-size: 9.5pt;
    padding: 2.5pt 6pt; border-bottom: 1.1px solid #000;
    text-transform: uppercase;
  }
  .section-content { padding: 3pt 6pt; }
  .field-line {
    display: flex; align-items: baseline; padding: 1.5pt 0;
    border-bottom: 1px dotted #999; font-size: 8.5pt;
  }
  .field-line:last-child { border-bottom: none; }
  .field-label {
    font-weight: bold; min-width: 120pt; padding-right: 6pt; flex-shrink: 0;
  }
  .field-value { flex: 1; font-weight: normal; min-height: 11pt; }
  .field-value.bold { font-weight: bold; }
  .field-value.amount { font-weight: bold; text-align: left; }
  .field-line.two-col {
    display: grid; grid-template-columns: 1fr 1fr; gap: 10pt; align-items: start;
  }
  .field-line.two-col .field-label { min-width: auto; }
  .field-line.two-col > div { display: flex; flex-direction: column; }
  .id-grid { display: grid; grid-template-columns: 1fr 1fr; }
  .id-grid .field-line {
    border-bottom: 1px dotted #999; padding: 2pt 5pt; font-size: 8.5pt;
  }
  .id-grid .field-line:nth-child(odd) { border-right: 1px solid #000; }
  .id-grid .field-line:nth-last-child(-n+2) { border-bottom: none; }
  .id-grid .field-label { min-width: 80pt; }
  .payment-options {
    display: flex; flex-direction: column; gap: 1.5pt; margin-top: 2pt;
  }
  .payment-option { display: flex; align-items: baseline; font-size: 8.5pt; }
  .payment-option .checkbox {
    display: inline-block; width: 9pt; height: 9pt; border: 1px solid #000;
    margin-right: 5pt; text-align: center; line-height: 8pt;
    font-size: 8pt; font-weight: bold; flex-shrink: 0;
  }
  .payment-option .option-label { font-weight: normal; margin-right: 4pt; }
  .payment-option .option-value {
    font-weight: bold; border-bottom: 1px dotted #999; flex: 1;
    padding-bottom: 1pt; min-height: 10pt;
  }
  .signature-zone { position: relative; min-height: 28pt; }
  .footer-row {
    display: flex; justify-content: space-between; align-items: flex-end;
    margin-top: auto; padding-top: 6pt;
  }
  .signature-contribuable { flex: 1; text-align: center; padding-right: 20pt; }
  .signature-contribuable .sig-line {
    width: 160pt; height: 1.2px; background: #000; margin: 0 auto 4pt auto;
  }
  .signature-contribuable .sig-label {
    font-size: 9pt; font-weight: bold; text-transform: uppercase;
  }
  .qr-zone { width: 70px; text-align: center; }
  .qr-zone img {
    width: 60px; height: 60px; border: 1px solid #ddd; padding: 2px; background: #fff;
  }
  .qr-zone .qr-label { font-size: 6pt; color: #666; margin-top: 1pt; }
</style>
</head>
<body>
<div class="page">

  <div class="main-title">Note de perception</div>

  <div class="doc-header">
    <div><span class="label">N° ${receiptNumber}</span></div>
    <div class="date">Du ${datePaiementAffichee}</div>
  </div>


   <div class="section">
    <div class="section-title">Identification du contribuable</div>
    <div class="id-grid">
      <div class="field-line">
        <span class="field-label">Nom ou Raison Sociale :</span>
        <span class="field-value bold">${nomContribuable}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Post-noms ou prénoms :</span>
        <span class="field-value">${fullContribuable?.prenoms || contribuable?.prenoms || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Adresse :</span>
        <span class="field-value">${adresseAffichage || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Commune :</span>
        <span class="field-value">${communeNom || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">B.P :</span>
        <span class="field-value">${fullContribuable?.boite_postale || contribuable?.boite_postale || ""}</span>
      </div>
      <div class="field-line">
        <span class="field-label">Tél. :</span>
        <span class="field-value">${fullPaiement?.client_phone || fullContribuable?.telephone || contribuable?.telephone || ""}</span>
      </div>
    </div>
  </div>



  
  <div class="section">
    <div class="section-title">1. - A REMPLIR PAR LE SERVICE TAXATEUR</div>
    <div class="section-content">

      <div class="field-line">
        <span class="field-label">Acte générateur (libellé) :</span>
        <span class="field-value bold">${taxeLibelle}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Article budgétaire (libellé) :</span>
        <span class="field-value">${periodeEcheance}</span>
      </div>

      <div class="field-line two-col">
        <div>
          <span class="field-label">Montant à payer</span>
          <span class="field-value amount">- en chiffres : ${formatCurrencyNP(montantTransaction)}</span>
        </div>
        <div>
          <span class="field-label">- en lettres :</span>
          <span class="field-value" style="font-size:8pt; line-height:1.2;">${montantEnLettres}</span>
        </div>
      </div>

      <div class="field-line">
        <span class="field-label">Nom de l'Agent Taxateur :</span>
        <span class="field-value bold">${agentTaxateurNom}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Qualité :</span>
        <span class="field-value">${agentTaxateurQualite}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Signature et Sceau :</span>
        <span class="field-value signature-zone"></span>
      </div>

    </div>
  </div>

 

  <div class="section">
    <div class="section-title">2. - A REMPLIR PAR LE SERVICE ORDONNATEUR</div>
    <div class="section-content">

      <div class="field-line">
        <span class="field-label">Date de réception :</span>
        <span class="field-value">${datePaiementAffichee}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Avis motivé de l'Ordonnateur :</span>
        <span class="field-value bold">Conforme</span>
      </div>

      <div class="field-line">
        <span class="field-label">Délai de paiement au plus tard le :</span>
        <span class="field-value"></span>
      </div>

      <div class="field-line">
        <span class="field-label">sous peine de pénalités de 100%</span>
        <span class="field-value"></span>
      </div>

      <div class="field-line two-col">
        <div>
          <span class="field-label">Montant visé</span>
          <span class="field-value amount">- en chiffres : ${formatCurrencyNP(montantTransaction)}</span>
        </div>
        <div>
          <span class="field-label">- en lettres :</span>
          <span class="field-value" style="font-size:8pt; line-height:1.2;">${montantEnLettres}</span>
        </div>
      </div>

      <div class="field-line">
        <span class="field-label">Nom et Signature de l'Ordonnateur :</span>
        <span class="field-value bold">${ordonnateurNom}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Code du Centre d'Ordonnancement :</span>
        <span class="field-value"></span>
      </div>

    </div>
  </div>

  <div class="section">
    <div class="section-title">3. - A REMPLIR PAR LE COMPTABLE</div>
    <div class="section-content">

      <div class="field-line">
        <span class="field-label">Code et désignation du bureau comptable :</span>
        <span class="field-value"></span>
      </div>

      <div class="field-line">
        <span class="field-label">Montant encaissé (en lettres) :</span>
        <span class="field-value" style="font-size:8pt; line-height:1.2;">${montantEnLettres}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Mode de paiement :</span>
        <span class="field-value bold">${getPaymentMethodLabelLocal()}</span>
      </div>

      <div class="payment-options">

        <div class="payment-option">
          <span class="checkbox">${getPaymentMethodLabelLocal() === "Espèces" ? "X" : ""}</span>
          <span class="option-label">a) Espèces :</span>
          <span class="option-value">${getPaymentMethodLabelLocal() === "Espèces" ? formatCurrencyNP(montantTransaction) : ""}</span>
        </div>

        <div class="payment-option">
          <span class="checkbox"></span>
          <span class="option-label">b) Chèque bancaire n°</span>
          <span class="option-value"></span>
          <span class="option-label" style="margin-left:6pt;">du</span>
          <span class="option-value" style="max-width:100pt;"></span>
        </div>

        <div class="payment-option">
          <span class="checkbox"></span>
          <span class="option-label">c) Chèque postal n°</span>
          <span class="option-value"></span>
          <span class="option-label" style="margin-left:6pt;">du</span>
          <span class="option-value" style="max-width:100pt;"></span>
        </div>

        <div class="payment-option">
          <span class="checkbox"></span>
          <span class="option-label">d) Bordereau de versement n°</span>
          <span class="option-value">${bordereauNumber}</span>
          <span class="option-label" style="margin-left:6pt;">du</span>
          <span class="option-value" style="max-width:100pt;">${datePaiementAffichee}</span>
        </div>

      </div>

      <div class="field-line" style="margin-top:3pt;">
        <span class="field-label">Numéro de la quittance :</span>
        <span class="field-value bold">${receiptNumber}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Date de la perception :</span>
        <span class="field-value">${datePaiementAffichee}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Nom du comptable :</span>
        <span class="field-value bold">${comptableNom}</span>
      </div>

      <div class="field-line">
        <span class="field-label">Signature :</span>
        <span class="field-value signature-zone"></span>
      </div>

    </div>
  </div>

  <div class="footer-row">
    <div class="signature-contribuable">
      <div class="sig-line"></div>
      <div class="sig-label">Signature du contribuable</div>
    </div>
    ${qrCodeBase64 ? `
    <div class="qr-zone">
      <img src="${qrCodeBase64}" alt="QR" />
      <div class="qr-label">Vérification</div>
    </div>
    ` : ""}
  </div>

</div>
</body>
</html>`;

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();
    iframe.contentWindow.onload = () => {
      iframe.contentWindow.document.title = fileName;
      iframe.contentWindow.print();
      setTimeout(() => {
        document.title = originalTitle;
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      }, 1500);
    };
  };

  // ==================== FIN NOTE DE PERCEPTION ====================

  const convertirMontantEnLettres = (montant) => {
    if (montant === 0) return "Zéro";
    const nombre = Math.floor(montant);
    if (nombre < 0) return "Moins " + convertirMontantEnLettres(-nombre);
    if (nombre > 999999999) return "Nombre trop grand";

    const unite = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf",
      "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize",
      "dix-sept", "dix-huit", "dix-neuf"];
    const dizaine = ["", "", "vingt", "trente", "quarante", "cinquante",
      "soixante", "soixante-dix", "quatre-vingt", "quatre-vingt-dix"];

    const convertToWords = (n) => {
      if (n < 20) return unite[n];
      if (n < 100) {
        const d = Math.floor(n / 10);
        const u = n % 10;
        if (d === 7 || d === 9) {
          const base = d === 7 ? "soixante-" : "quatre-vingt-";
          if (u === 0) return d === 7 ? "soixante-dix" : "quatre-vingts";
          if (u === 1) return base + "onze";
          return base + unite[10 + u];
        }
        let result = dizaine[d];
        if (u === 0) return result;
        if (u === 1 && d !== 8) return result + "-et-un";
        if (d === 8 && u === 1) return result + "-un";
        return result + "-" + unite[u];
      }
      if (n < 1000) {
        const c = Math.floor(n / 100);
        const r = n % 100;
        let result = "";
        if (c === 1) result = "cent";
        else result = unite[c] + "-cent";
        if (r === 0) {
          if (c > 1) result = unite[c] + "-cents";
          return result;
        }
        if (c > 1 && r < 10) result = unite[c] + "-cent";
        return result + "-" + convertToWords(r);
      }
      return "";
    };

    const convertThousands = (n) => {
      if (n === 0) return "";
      const milliers = Math.floor(n / 1000);
      const reste = n % 1000;
      let result = milliers === 1 ? "mille" : convertToWords(milliers) + "-mille";
      if (reste > 0) result += "-" + convertToWords(reste);
      return result;
    };

    let result = "";
    if (nombre >= 1000000) {
      const millions = Math.floor(nombre / 1000000);
      const reste = nombre % 1000000;
      result = millions === 1 ? "un-million" : convertToWords(millions) + "-millions";
      if (reste > 0) {
        result += "-" + (reste < 1000 ? convertToWords(reste) : convertThousands(reste));
      }
    } else if (nombre >= 1000) {
      result = convertThousands(nombre);
    } else {
      result = convertToWords(nombre);
    }

    result = result.replace(/--/g, "-").replace(/^-/, "").replace(/-$/, "");
    return result.charAt(0).toUpperCase() + result.slice(1);
  };

  const generateThermalReceiptText = () => {
    const receiptNumber = transaction?.reference || `RCP-${Date.now()}`;
    const montantPaye = transaction?.amount || 0;
    const periodLabel = transaction?.period || "Période non spécifiée";
    const agentNom = agentInfo
      ? `${agentInfo.admin_fname || ''} ${agentInfo.admin_lname || ''}`.trim() || agentInfo.full_name || "Agent"
      : "Agent non spécifié";

    const ESC = '\x1B';
    const GS = '\x1D';
    const init = ESC + '\x40';
    const center = ESC + '\x61' + '\x01';
    const left = ESC + '\x61' + '\x00';
    const bold = ESC + '\x45' + '\x01';
    const boldOff = ESC + '\x45' + '\x00';
    const doubleSize = GS + '\x21' + '\x30';
    const normal = GS + '\x21' + '\x00';
    const cut = GS + '\x56' + '\x42' + '\x00';

    const separator = '='.repeat(32) + '\n';
    const dashLine = '-'.repeat(32) + '\n';

    let text = '';
    text += init;
    text += center + doubleSize + 'SYNCTAXE\n' + normal;
    text += center + 'Solutions fiscales innovantes\n';
    text += separator;
    text += left + bold + 'REÇU DE PAIEMENT\n' + boldOff;
    text += `N°: ${receiptNumber}\n`;
    text += `Date: ${new Date().toLocaleString('fr-FR')}\n`;
    text += separator;
    text += bold + 'CONTRIBUABLE\n' + boldOff;
    text += `Nom: ${contribuable?.nom_contribuable || 'Non spécifié'}\n`;
    text += `ID: ${contribuable?.contribuable_id || 'N/A'}\n`;
    text += `Tél: ${contribuable?.telephone || 'Non spécifié'}\n`;
    text += dashLine;
    text += bold + 'TAXE\n' + boldOff;
    text += `Désignation: ${transaction?.taxName || 'Taxe'}\n`;
    text += `Période: ${periodLabel}\n`;
    text += dashLine;
    text += bold + 'MONTANTS\n' + boldOff;
    text += `Payé: ${formatCurrency(montantPaye)}\n`;
    text += dashLine;
    text += bold + 'AGENT COLLECTEUR\n' + boldOff;
    text += `Nom: ${agentNom}\n`;
    if (agentInfo?.admin_fonction) text += `Fonction: ${agentInfo.admin_fonction}\n`;
    text += dashLine;
    text += `STATUT: PAYÉ\n`;
    text += separator;
    text += center + 'MERCI DE VOTRE CONFIANCE\n';
    text += center + 'www.synctaxes.com\n';
    text += '\n\n\n\n';
    text += cut;

    return text;
  };

  const scanUsbDevices = async () => { /* ... */ };
  const printOnUsbDevice = async () => { /* ... */ };
  const connectToSerialPort = async () => { /* ... */ };
  const printOnSerialPort = async () => { /* ... */ };

  const handleRetour = () => {
    localStorage.removeItem('pendingTransaction');
    navigate(-2);
  };

  if (!transaction && !apiError) {
    return (
      <>
        <Header />
        <div className="main main-app p-3 p-lg-4" style={{ background: '#f5f7fa', minHeight: '100vh' }}>
          <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <Card className="border-0 shadow-sm rounded-4 text-center" style={{ maxWidth: '500px', width: '100%' }}>
              <Card.Body className="p-5">
                <div className="mb-4">
                  <div className="pulse-animation mx-auto d-flex align-items-center justify-content-center"
                       style={{ width: '80px', height: '80px', background: 'linear-gradient(135deg, #0d6efd, #0a58ca)', borderRadius: '50%' }}>
                    <Spinner animation="border" variant="light" style={{ width: '2rem', height: '2rem' }} />
                  </div>
                </div>

                <h4 className="fw-bold mb-2">Chargement en cours</h4>
                <p className="text-muted mb-4">Récupération des informations de votre paiement...</p>

                <div className="d-flex justify-content-center gap-2 mb-4">
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.15s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.3s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.45s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.6s' }} />
                </div>

                <div className="mx-auto" style={{ width: '200px' }}>
                  <div className="progress" style={{ height: '4px', borderRadius: '2px' }}>
                    <div className="progress-bar progress-bar-striped progress-bar-animated bg-primary" style={{ width: '100%' }} />
                  </div>
                </div>

                <div className="mt-4">
                  <small className="text-muted">
                    <InfoCircle className="me-1" size={12} />
                    Cette opération peut prendre quelques secondes
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Container>

          <style>{`
            .pulse-animation { animation: pulse 1.5s ease-in-out infinite; }
            @keyframes pulse {
              0% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.4); }
              50% { transform: scale(1.05); opacity: 0.9; box-shadow: 0 0 0 15px rgba(13, 110, 253, 0); }
              100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(13, 110, 253, 0); }
            }
          `}</style>

          <Footer />
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh' }}>
        <Container>
          <Card className="border-0 shadow-lg text-center py-5">
            <Card.Body>
              <div className="mb-4">
                <div className="success-icon-circle mx-auto mb-3"><CheckCircle size={64} className="text-success" /></div>
                <h2 className="mb-3 text-success">Paiement réussi !</h2>
                <p className="text-muted mb-4">La collecte a été effectuée avec succès.</p>
              </div>

              {transaction && (
                <div className="text-start bg-light p-4 rounded-3 mb-4">
                  <h6 className="mb-3 text-primary">Détails de la transaction :</h6>
                  <Row className="g-3">
                    <Col md={6}>
                      <p className="mb-2"><strong>Référence :</strong> <code>{transaction.reference}</code></p>
                      <p className="mb-2"><strong>Montant :</strong> <span className="text-success fw-bold">{formatCurrency(transaction.amount)}</span></p>
                      <p className="mb-2"><strong>Type :</strong> {transaction.paymentType === "full" ? "Collecte complète" : "Collecte partielle"}</p>
                    </Col>
                    <Col md={6}>
                      <p className="mb-2"><strong>Méthode :</strong> {getPaymentMethodLabel()}</p>
                      <p className="mb-2"><strong>Contribuable :</strong> {contribuable?.nom_contribuable || 'Non spécifié'}</p>
                      <p className="mb-0"><strong>Date :</strong> {formatDateTime(transaction.timestamp)}</p>
                    </Col>
                  </Row>

                  {agentInfo && (agentInfo.nom || agentInfo.prenom) && (
                    <div className="mt-3 pt-3 border-top">
                      <h6 className="text-primary mb-2">
                        <Person className="me-2" size={14} />
                        Agent collecteur
                      </h6>
                      <div className="d-flex flex-wrap gap-4">
                        <div>
                          <small className="text-muted">Nom complet</small>
                          <p className="mb-0 fw-semibold">{agentInfo.prenom} {agentInfo.nom}</p>
                        </div>
                        <div>
                          <small className="text-muted">Fonction</small>
                          <p className="mb-0">{agentInfo.fonction || 'Agent de collecte'}</p>
                        </div>
                        {agentInfo.matricule && (
                          <div>
                            <small className="text-muted">Matricule / ID</small>
                            <p className="mb-0"><code>{agentInfo.matricule}</code></p>
                          </div>
                        )}
                        {agentInfo.telephone && (
                          <div>
                            <small className="text-muted">Téléphone</small>
                            <p className="mb-0">{agentInfo.telephone}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}

              <div className="mt-4">
                <h5 className="mb-3">Documents disponibles</h5>
                <Row className="g-3 justify-content-center">
                  <Col md={6}>
                    <div
                      className="document-card p-3 rounded-3 border text-center h-100"
                      onClick={() => {
                        if (paiementComplet) {
                          generateBordereauPaiement(paiementComplet);
                        } else {
                          alert("Les données du paiement ne sont pas encore disponibles");
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <FilePdf size={40} className="text-danger mb-2" />
                      <h6 className="mb-1">Quittance de paiement</h6>
                      <p className="text-muted small mb-0">Reçu officiel A4</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div
                      className="document-card p-3 rounded-3 border text-center h-100"
                      onClick={generateNotePerception}
                      style={{ cursor: 'pointer' }}
                    >
                      <FilePdf size={40} className="text-primary mb-2" />
                      <h6 className="mb-1">Note de perception</h6>
                      <p className="text-muted small mb-0">Note de débit de taxation</p>
                    </div>
                  </Col>
                </Row>
              </div>

              <div className="d-flex gap-3 justify-content-center mt-4">
                <Button variant="outline-secondary" onClick={handleRetour}><ArrowLeft className="me-2" /> Retour</Button>
              </div>
            </Card.Body>
          </Card>
        </Container>
        <Footer />
      </div>

      <Modal show={showUsbModal} onHide={() => { setShowUsbModal(false); setUsbDevices([]); setSelectedUsbDevice(null); setUsbError(''); }} size="md" centered>
        <Modal.Header closeButton className="bg-primary text-white"><Modal.Title><Usb className="me-2" /> Impression USB</Modal.Title></Modal.Header>
        <Modal.Body>
          {usbError && <Alert variant="warning" className="mb-3"><ExclamationTriangle className="me-2" />{usbError}</Alert>}
          {scanningUsb ? (
            <div className="text-center py-4"><Spinner animation="border" variant="primary" /><p className="mt-2 text-muted">{usbStatus}</p></div>
          ) : usbDevices.length > 0 ? (
            <>
              <p className="text-muted mb-3">Sélectionnez votre imprimante :</p>
              <ListGroup className="mb-3">
                {usbDevices.map((device, idx) => (
                  <ListGroup.Item key={idx} className={`d-flex justify-content-between align-items-center ${selectedUsbDevice?.id === device.id ? 'active' : ''}`} style={{ cursor: 'pointer' }} onClick={() => setSelectedUsbDevice(device)}>
                    <div><strong>{device.name}</strong><small className="d-block text-muted">VID:${device.vendorId?.toString(16)} PID:${device.productId?.toString(16)}</small></div>
                    <Badge bg={selectedUsbDevice?.id === device.id ? "success" : "secondary"}>{selectedUsbDevice?.id === device.id ? "Sélectionné" : "Disponible"}</Badge>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </>
          ) : (
            <div className="text-center py-4">
              <Usb size={48} className="text-muted mb-3 opacity-50" />
              <p>{usbStatus || "Aucune imprimante USB trouvée"}</p>
              <Button variant="primary" onClick={scanUsbDevices} disabled={scanningUsb}><Search className="me-2" size={14} /> Rechercher une imprimante USB</Button>
              <div className="mt-3 text-muted small"><InfoCircle className="me-1" size={12} /> Branchez votre imprimante USB puis cliquez sur Rechercher</div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowUsbModal(false)}>Annuler</Button>
          <Button variant="success" onClick={printOnUsbDevice} disabled={!selectedUsbDevice || printingUsb}>
            {printingUsb ? <><Spinner size="sm" className="me-2" />Impression...</> : <><Printer className="me-2" />Imprimer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSerialModal} onHide={() => { setShowSerialModal(false); setSelectedPort(null); }} size="md" centered>
        <Modal.Header closeButton className="bg-success text-white"><Modal.Title><UsbC className="me-2" /> Port série (RS232)</Modal.Title></Modal.Header>
        <Modal.Body>
          {!selectedPort ? (
            <div className="text-center py-4">
              <UsbC size={48} className="text-muted mb-3 opacity-50" />
              <p>Sélectionnez un port série</p>
              <div className="mt-3">
                <Form.Label>Débit (baudrate):</Form.Label>
                <Form.Select value={baudRate} onChange={(e) => setBaudRate(parseInt(e.target.value))} className="mb-3">
                  <option value="9600">9600 bauds</option>
                  <option value="19200">19200 bauds</option>
                  <option value="38400">38400 bauds</option>
                  <option value="115200">115200 bauds</option>
                </Form.Select>
                <Button variant="primary" onClick={connectToSerialPort}>Sélectionner le port</Button>
              </div>
            </div>
          ) : (
            <div className="text-center py-4">
              <p>Port série sélectionné</p>
              <p className="text-success"><CheckCircle className="me-1" /> Prêt pour l'impression</p>
              <div className="alert alert-info small mt-3"><InfoCircle className="me-1" /> Assurez-vous que l'imprimante est allumée et connectée</div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowSerialModal(false)}>Annuler</Button>
          <Button variant="success" onClick={printOnSerialPort} disabled={!selectedPort || printingUsb}>
            {printingUsb ? <><Spinner size="sm" className="me-2" />Impression...</> : <><Printer className="me-2" />Imprimer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .success-icon-circle { width: 100px; height: 100px; background: rgba(25, 135, 84, 0.1); border-radius: 50%; display: flex; align-items: center; justify-content: center; border: 3px solid rgba(25, 135, 84, 0.2); }
        .document-card { transition: all 0.2s ease; background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%); cursor: pointer; }
        .document-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); border-color: #0d6efd !important; }
      `}</style>
    </>
  );
};

export default PaiementSuccesPage;